import qs from "qs";

import { axiosWithAuth } from "helpers";
import { mapFilterCreditReviewDataToServer } from "mappers";

export const allMerchantService = {
	claimMerchant,
	getAllMerchant,
	getHistorical,
	getInReview,
	unClaimMerchant,
};

const API_URL = process.env.REACT_APP_API_URL;

function getAllMerchant({ page, filters, sortBy }) {
	const body = mapFilterCreditReviewDataToServer({
		page,
		filters,
		sortBy,
	});
	const options = {
		url: `${API_URL}/api/credit_reviews/all_merchants`,
		params: body,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function getInReview({ page, filters, sortBy }) {
	const body = mapFilterCreditReviewDataToServer({
		page,
		filters,
		sortBy,
	});
	const options = {
		url: `${API_URL}/api/credit_reviews/in_review`,
		params: body,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function getHistorical({ page, filters, sortBy }) {
	const body = mapFilterCreditReviewDataToServer({
		page,
		filters,
		sortBy,
	});
	const options = {
		url: `${API_URL}/api/credit_reviews/historical`,
		params: body,
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function claimMerchant({ id }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/credit_reviews/${id}/assign`,
	};

	return axiosWithAuth(options);
}

function unClaimMerchant({ id }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/credit_reviews/${id}/unassign`,
	};

	return axiosWithAuth(options);
}
